<!DOCTYPE html>
<html lang="en">

    <head>

        <meta charset="utf-8">
        <meta http-equiv="X-UA-Compatible" content="IE=edge">
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
        <meta name="description" content="">
        <meta name="author" content="">

        <title>Dashboard</title>

    </head>

    <body id="page-top">

        <div>
            <app-public-menu [contact]="appContact" [about]="appAbout"></app-public-menu>
            <app-home-image></app-home-image>
            <app-about #appAbout></app-about>
            <app-contact #appContact></app-contact>
            <app-footer-common></app-footer-common>
        </div>
    </body>

</html>